import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
                <i className="ri-gamepad-line text-lg"></i>
              </div>
              <span className="font-heading text-xl text-background-50 whitespace-nowrap">
                黄油游戏大全
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              最全的黄油游戏收录与推荐平台，为玩家提供详细的游戏评测、下载指引与攻略指南。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/rpg" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">游戏分类</Link>
              <Link to="/article/top-rpg-games-2025" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">游戏攻略</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4">游戏分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/rpg" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">RPG角色扮演</Link>
              <Link to="/category/slg" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">SLG策略模拟</Link>
              <Link to="/category/avg" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">AVG文字冒险</Link>
              <Link to="/category/act" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">ACT动作游戏</Link>
              <Link to="/category/simulation" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">模拟经营</Link>
              <Link to="/category/indie" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">独立游戏</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-50 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2 text-sm text-background-400">
              <div className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@hdyxdaquan.com</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-chat-3-line text-primary-400"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </div>
              <div className="flex items-center gap-2 mt-2">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all" aria-label="B站">
                  <i className="ri-bilibili-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all" aria-label="QQ">
                  <i className="ri-qq-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 黄油游戏大全. 版权所有.
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}